import React, { useState, useLayoutEffect } from 'react'
import { Box } from '@mui/system'
import { Dialog, Typography, Button, FormControl, FormControlLabel, Radio, FormLabel, RadioGroup} from '@mui/material'
import { translate, Translate, Localize } from 'react-i18nify';
import PatientDashboardCategory from "../../components/Patient/PatientDashboardCategory";
import { PatientDetailText , } from "../../components/Patient/PatientDetailText";
import PatientDashboardCategoryCriticalWarning from "../../components/Patient/PatientDashboardCategoryCriticalWarning";
import PatientInfoComponent from "../../components/Patient/PatientInfo";
import { PatientTreatmentInfoComponent } from "../../components/Patient/PatientTreatmentInfo";
import PatientDeviceInformation from "../../components/Patient/PatientDeviceInformation";
import TimeUtils from '../../utils/TimeUtils';
import { useRef, useEffect } from 'react';
import { DeviceService,  PatientService, TreatmentService } from '../../services/DataService';
import { PatientLog } from "../../components/Patient/PatientLog";
import PatientDashboardCategoryWarning from '../../components/Patient/PatientDashboardCategoryWarning';
import { useNavigate } from 'react-router-dom';



export const InstallerDetailsDialog = (props) => {

    const navigate = useNavigate();
    const DetailDialogContainerRef = useRef(null);
    const data = props.data;
    const [awaitingDevice, setAwaitingDevice] = useState(null)
    const [locationMismatch, setlocationMismatch] = useState(null);
    const [detailedPatient, setDetailedPatient] = useState();
    const [detailedCurrentTreatment, setDetailedCurrentTreatment] = useState(null);
    const [detailedCurrentTreatmentTimestamp, setDetailedCurrentTreatmentTimestamp] = useState(null);
    const [detailedPrescribedTreatment, setDetailedPrescribedTreatment] = useState(null);
    const [detailedComponent, setDetailedComponent] = useState(null);
    const abortControllerRef = useRef(null);
    
    let id = data?.patientId

    const handleEntered = () => {
        if (DetailDialogContainerRef.current) {
            //setWidth(DetailDialogContainerRef.current.clientWidth);
        }
    }

    const clearState = () => {
        setDetailedComponent(null);
        setDetailedCurrentTreatment(null)
        setDetailedPatient(null)
        setDetailedPrescribedTreatment(null)
        setDetailedCurrentTreatmentTimestamp(null)
    }

    const handleEdit = () => {
        navigate("/patient/" + id + "/edit", { replace: true });
    };

    useEffect(() => {
        if(props.open == true){
            var abortController = new AbortController()
            abortControllerRef.current = abortController;
            const patient = props.data.patient;
            const component = props.data.component;
            const currentTreatment = props.data.currentTreatment;
            (async () => {
                if(patient != null){
                    const id = props.data.patient.patient != null ? props.data.patient.patient.id.value : props.data?.patientId ? props.data?.patientId : null
                    if(id != null){
                        await PatientService.get(id, abortControllerRef.current).then((result) => {
                            if(abortControllerRef.current.signal.aborted) 
                                return; // check if the request was aborted
            
                            setDetailedPatient(result.data);
                            setDetailedPrescribedTreatment(result.data.prescribedTreatment)
                        }).catch((err) => {
                            console.error(err); //Mabye display an error
                        });
                    }   
                }
                if(component != null){
                    setAwaitingDevice(true)
                    if((patient != null && patient.componentLink.end == null) || (patient == null)){
                        const udsn = props.data.component.metaData.find(md => md.name == "Serial Number").value
                        await DeviceService.getDeviceByUdsn(udsn, abortControllerRef.current).then((result) => {
                            if(abortControllerRef.current.signal.aborted) 
                                return; // check if the request was aborted
                            setDetailedComponent(result.data)
                            setAwaitingDevice(false)
                        }).catch((err) => {
                            console.error(err)//Mabye display an error
                        })
                    }
                }
                if(currentTreatment != null){
                    const treatmentId = props.data.currentTreatment.treatmentId
                    await TreatmentService.get(treatmentId, abortControllerRef.current).then((result) => {
                        if(abortControllerRef.current.signal.aborted) 
                            return; // check if the request was aborted        
                        setDetailedCurrentTreatment(result.data)
                    }).catch((err) => {
                        console.error(err)
                    })                    
                }else {
                    setDetailedCurrentTreatment("Unknown")
                }
                if(currentTreatment != null && props.data.component != null){
                    await PatientService.getTreatmentInstallationConfirmation(id, data.component?.id, abortControllerRef.current).then((result) => {
                        if(abortControllerRef.current.signal.aborted) 
                            return; // check if the request was aborted        
                        setDetailedCurrentTreatmentTimestamp(result.data)
                    }).catch((err) => {
                        console.error(err)
                        setDetailedCurrentTreatmentTimestamp("Unknown")
                    })
                }else {
                    setDetailedCurrentTreatmentTimestamp("Unknown")
                }
            })();

        }else if(props.open == false){
            clearState();
            if(abortControllerRef.current !== null){
                abortControllerRef.current.abort();
            }    
        }
    },[props.open])

    if (!props.open) {
        return null;
    }

    return (

        <Dialog
            fullWidth
            maxWidth="md"
            sx={{ width: "100%", p: 0 }}
            open={props.open}
            onClose={() => { props.onClose() }}
            TransitionProps={{ onEntered: handleEntered }}
        >
            <Box sx={{ py:1, px: 2, display:"flex", flexDirection: "column" }}>
                {props.data?.patient?.deleted != null ?
                    
                    <Box id={1} sx={{width:"100%"}}>
                    <Box id={2} sx={{ mt: 1, borderRadius: "15px", border: 1, borderColor: "primary.main", bgcolor: "primary.main", color: "primary.contrastText", p: 2, display:"flex", flexDirection:"column", justifyContent: 'space-between'}}>
                        <Typography sx={{ mt: 1 }} variant="body">
                            {<Translate value="PatientInformation" />}
                        </Typography>

                        <Box sx={{mt: 2}}>
                            <PatientDetailText // O2matic ID
                                label={<Translate value="O2maticId" />}
                                value={detailedPatient?.patient?.id?.value ? detailedPatient?.patient?.id?.value : "-"}
                            ></PatientDetailText>
                        </Box>

                        <PatientDashboardCategoryCriticalWarning
                            title={translate("PatientHasBeenDeleted")}
                        />
                    </Box>
                    </Box>
                    
                :
                    props.data?.patient != null ?
                        <Box
                            sx={{
                            mb: 1,
                            //width: { xs: "100%", sm: "100%", md: "100%", lg: "1000px" },
                            maxWidth: {md: "1000px"},
                            display: "flex",
                            flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
                            justifyContent: 'space-between',
                            }}
                        >

                            <Box
                                sx={{
                                width: { xs: "100%", sm: "100%", md: "49%", lg: "49%" },
                                display: "flex", alignItems: 'flex-start'
                                }}
                            >
                                <PatientInfoComponent
                                patient={detailedPatient}
                                locationMismatch={locationMismatch}
                                handleEdit={handleEdit}
                                handleLiveData={null}
                                liveData={null}
                                showLiveDataButton={false}
                                />
                            </Box>

                            <Box
                            sx={{
                                width: { xs: "100%", sm: "100%", md: "49%", lg: "49%" },
                                display: "flex"
                            }}
                            >
                                <PatientTreatmentInfoComponent 
                                patientId={id}
                                treatment={detailedPrescribedTreatment}
                                treatmentPending={detailedCurrentTreatment?.id != detailedPrescribedTreatment?.id}
                                previousTreatment={detailedCurrentTreatment}
                                deviceCurrentTreatment={detailedCurrentTreatmentTimestamp}
                                />
                            </Box>
                        </Box>
                    :
                    //Show Patient not connect / no patient on device
                    //Maybe just remove this? 
                    <Box id={1} sx={{width:"100%"}}>
                    <Box id={2} sx={{ mt: 1, borderRadius: "15px", border: 1, borderColor: "primary.main", bgcolor: "primary.main", color: "primary.contrastText", p: 2, display:"flex", flexDirection:"column", justifyContent: 'space-between'}}>
                        <Typography sx={{ mt: 1 }} variant="body">
                            {<Translate value="PatientInformation" />}
                        </Typography>

                        <Box sx={{mt: 2}}>
                            <PatientDetailText // O2matic ID
                                label={<Translate value="O2maticId" />}
                                value={detailedPatient?.patient?.id?.value ? detailedPatient?.patient?.id?.value : "-"}
                            ></PatientDetailText>
                        </Box>

                        <PatientDashboardCategoryWarning
                            title={translate("NoPatientOnDevice")}
                        />
                    </Box>
                    </Box>

                }

                <Box
                    sx={{ width:"100%", mt:1, display: "flex", flexDirection: { xs: "column", md: "row" } }}
                >
                    <PatientDeviceInformation patient={detailedPatient} device={detailedComponent} locationMismatch={locationMismatch} awaitingDevice={awaitingDevice} installerView={true} />
                </Box>

                {id === null ? null :
                    <Box sx={{ width: "100%", display: "flex" }} >
                        <PatientLog id={id} /> 
                    </Box>
                }
                

            </Box>
        </Dialog>
    )
}
